export default __webpack_public_path__ + "static/media/MystryBlog1.de2cf394.jpeg";